interface ICascadeScenario {
    scenarioId?: string | number | null;
    meta?: {
        settingsType?: string | null;
    } | null;
}

export function getCascadeScenarioRefreshKey(scenario?: ICascadeScenario | null): string | null {
    if (scenario?.meta?.settingsType !== "cascade") {
        return null;
    }

    const scenarioId = scenario.scenarioId;
    if (scenarioId === null || scenarioId === undefined) {
        return null;
    }

    return String(scenarioId);
}

export function shouldReloadCascadeScenarioStatus(
    currentScenarioActive: boolean,
    liveReadiness: boolean,
): boolean {
    return Boolean(currentScenarioActive) !== Boolean(liveReadiness);
}

export function hasCascadeReadinessChanged(
    previousReadiness: boolean | null,
    liveReadiness: boolean,
): boolean {
    return previousReadiness === null || previousReadiness !== liveReadiness;
}
